import { nn } from 'date-fns/locale/nn';

import localize from './localize';

export default {
  ...nn,
  localize,
};
